// El estado persistido conserva el ciclo documental. Esta proyección es la
// única fuente para comunicar el ciclo logístico al operador.
export const FOJA_OPERATIONAL_STATUS = Object.freeze({
  BORRADOR: 'borrador',
  EN_VIAJE: 'en_viaje',
  RECIBIDA: 'recibida',
  RECIBIDA_PARCIAL: 'recibida_parcial',
  ANULADA: 'anulada',
});

const STATUS_BY_DOCUMENT_STATE = Object.freeze({
  borrador: FOJA_OPERATIONAL_STATUS.BORRADOR,
  cerrada: FOJA_OPERATIONAL_STATUS.EN_VIAJE,
  despachada_confirmada: FOJA_OPERATIONAL_STATUS.EN_VIAJE,
  recibida: FOJA_OPERATIONAL_STATUS.RECIBIDA,
  recibida_parcial: FOJA_OPERATIONAL_STATUS.RECIBIDA_PARCIAL,
  anulada: FOJA_OPERATIONAL_STATUS.ANULADA,
});

const PRESENTATION = Object.freeze({
  [FOJA_OPERATIONAL_STATUS.BORRADOR]: { label: 'Borrador', variant: 'outline' },
  [FOJA_OPERATIONAL_STATUS.EN_VIAJE]: { label: 'En viaje', variant: 'default' },
  [FOJA_OPERATIONAL_STATUS.RECIBIDA]: { label: 'Recibida', variant: 'default' },
  [FOJA_OPERATIONAL_STATUS.RECIBIDA_PARCIAL]: { label: 'Recepción parcial', variant: 'warning' },
  [FOJA_OPERATIONAL_STATUS.ANULADA]: { label: 'Anulada', variant: 'danger' },
});

export const getFojaOperationalStatus = (estado) =>
  STATUS_BY_DOCUMENT_STATE[String(estado || '').trim().toLowerCase()] || String(estado || '').trim().toLowerCase();

export const getFojaStatusPresentation = (estado) => {
  const operationalStatus = getFojaOperationalStatus(estado);
  return PRESENTATION[operationalStatus] || { label: estado || 'Sin estado', variant: 'outline' };
};

export const isFojaInTransit = (estado) =>
  getFojaOperationalStatus(estado) === FOJA_OPERATIONAL_STATUS.EN_VIAJE;

export const getFojaDocumentaryHint = (foja = {}) => {
  if (String(foja.estado || '').toLowerCase() === 'cerrada') return 'Cerrada para modificaciones · salida pendiente de confirmar';
  if (String(foja.estado || '').toLowerCase() === 'despachada_confirmada') return 'Cerrada para modificaciones';
  return null;
};
